import React from 'react';
import './CardThreeUp.scss';
import { renderCards } from '../UI/Card/util/renderCards';
import { getModuleBackgroundColor } from '../../util/getModuleBackgroundColor';

/**
 * Renders the card three up component
 * @param {boolean} isHubspot
 * @param {string} eyebrowText - label for the section
 * @param {('small'|'large')} eyebrowType - small or large eyebrow styling
 * @param {array} cards - collection of card blocks
 * @param {('white-cards'|'gray-cards')} type
 * @param {boolean} centerTitle
 * @returns {JSX.Element}
 * @constructor
 */
const CardThreeUp = ({ isHubspot, eyebrowText, eyebrowType, cards, type, centerTitle }) => (
  <div
    className={`c-card-three-up ${
      type === 'white-cards' ? getModuleBackgroundColor('gray') : getModuleBackgroundColor('white')
    }`}
  >
    <div className="c-card-three-up__inner">
      <div
        className={`c-card-three-up__eyebrow ${
          eyebrowType === 'small' ? 'eyebrow-1' : 'h2-roobert'
        } ${centerTitle ? 'is-centered' : ''}`}
      >
        {eyebrowType === 'small' ? <span>{eyebrowText}</span> : <h2>{eyebrowText}</h2>}
      </div>
      <div
        className={`c-card-three-up__cards-container ${isHubspot ? 'hubspot-margin' : ''} ${
          cards.length <= 3 ? 'flex-start' : ''
        }`}
      >
        {renderCards(cards)}
      </div>
    </div>
  </div>
);

export default CardThreeUp;
